// material-ui
import useMediaQuery from '@mui/material/useMediaQuery';
import IconButton from '@mui/material/IconButton';
import Link from '@mui/material/Link';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import Typography from '@mui/material/Typography';
import HelpOutlineIcon from '@mui/icons-material/HelpOutline';
import CloseIcon from '@mui/icons-material/Close';
import { useLocation } from 'react-router-dom';
import { useState } from 'react';

// project imports
import Search from './Search';
import Profile from './Profile';
import Notification from './Notification';
import MobileSection from './MobileSection';
import SetupProgressButton from './SetupProgressButton';
import PlanNavbarBadge from './PlanNavbarBadge';
import { useTour } from 'contexts/TourContext';
import { getPageHelpContent } from 'config/tourConfig';

// project import
import { GithubOutlined } from '@ant-design/icons';

// ==============================|| HEADER - CONTENT ||============================== //

export default function HeaderContent() {
  const downLG = useMediaQuery((theme) => theme.breakpoints.down('lg'));
  const { pathname } = useLocation();
  const { startPageTour } = useTour();
  const [helpOpen, setHelpOpen] = useState(false);
  const helpContent = getPageHelpContent(pathname);

  const handleStartTour = () => {
    setHelpOpen(false);
    startPageTour(pathname);
  };

  return (
    <>
      {!downLG && <Search />}

      {downLG && <Box sx={{ flexGrow: 1, ml: 1 }} />}
      {/* <IconButton
        component={Link}
        href="https://github.com/Brainscraft/mantis-free-react-admin-template"
        target="_blank"
        disableRipple
        color="secondary"
        title="Download Free Version"
        sx={{ color: 'text.primary', bgcolor: 'grey.100' }}
      >
        <GithubOutlined />
      </IconButton> */}

      {/* <Notification /> */}
      <PlanNavbarBadge />
      <SetupProgressButton />
      {helpContent && (
        <Button
          variant="outlined"
          size="small"
          startIcon={<HelpOutlineIcon />}
          onClick={() => setHelpOpen(true)}
          sx={{ textTransform: 'none', borderRadius: 2, ml: 1 }}
        >
          Help
        </Button>
      )}
      {!downLG && <Profile />}
      {downLG && <MobileSection />}

      {helpContent && (
        <Dialog open={helpOpen} onClose={() => setHelpOpen(false)} maxWidth="sm" fullWidth>
          <DialogTitle sx={{ pr: 6 }}>
            {helpContent.title}
            <IconButton
              aria-label="close"
              onClick={() => setHelpOpen(false)}
              sx={{ position: 'absolute', right: 8, top: 8 }}
            >
              <CloseIcon />
            </IconButton>
          </DialogTitle>
          <DialogContent dividers>
            <Typography variant="body1" color="text.secondary" sx={{ mb: 2 }}>
              {helpContent.description}
            </Typography>
            <Box component="ul" sx={{ pl: 2, m: 0, color: 'text.secondary', '& li': { mb: 0.5 } }}>
              {helpContent.bullets.map((bullet, i) => (
                <li key={i}>{bullet}</li>
              ))}
            </Box>
          </DialogContent>
          <DialogActions>
            <Button onClick={() => setHelpOpen(false)}>Close</Button>
            <Button variant="contained" onClick={handleStartTour}>
              Start Tour
            </Button>
          </DialogActions>
        </Dialog>
      )}
    </>
  );
}
